module.exports = __webpack_public_path__ + "r-v3/img/sticker_18.159def0e.svg";